<div class="grid-container">
    <div class="grid-x grid-margin-x">
        <div class="cell large-3 medium-3 small-4">
            {{document.id}}
        </div>
        <div class="cell large-1 medium-1 small-2">
            <span [ngClass]="{ 'upload-error' : document.uploadStatus == statuses.Error, 'upload-progress' : document.uploadStatus == statuses.Uploading, 'upload-complete': document.uploadStatus == statuses.Complete }">
                {{ document.uploadStatus }}
            </span>
        </div>
        <div class="cell large-8 medium-6 small-6">
            <text-loader [run]="document.uploadStatus == statuses.Uploading" [text]="''" [tickType]="'.'" [interval]="1000"></text-loader>
        </div>
    </div>
</div>